<template>
  <div v-if="object">
    <div class="row text-white" :style="object.archivedDate ? 'background: #293b2e' : 'background: #2e714a'">
      <div class="col-md-8" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>{{item.object.ipr.client.name}}</b>
      </div>
      <div class="col-md-4" style="text-align: right">
        <i v-if="!inSave && !object.archivedDate" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
        <b v-else-if="object.archivedDate">В АРХИВЕ</b>
      </div>
    </div>

    <div v-if="object.id === 0" class="row">
      <div class="col-md-6">
        <items-option :label="'Базовое ТСР'" :object="object.basis" @update="setBasis" :type="'base_tsr'">
        </items-option>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <base-input label="Дополнительная информация"
                    v-model="object.note"
                    :value="object.note"
        ></base-input>
      </div>
    </div>

    <div v-if="deleteAllowed" class="row" style="padding-bottom: 15px">
      <div class="col-md-12" style="text-align: right">
        <base-button @click="kill" :size="'sm'" type="warning" fill>Удалить</base-button>
      </div>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";
 import {authHeader} from "@/services/auth-header";
 import {getPeriods} from "@/services/periods-service";
 import {userService} from "@/services/user.service";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       category: null,
       inSave: false,
       deleteAllowed: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       this.inSave = true;
       try {
         let renewed = await this.$repo.save(this.object, this.type);
         if (renewed) {
           this.item.object = renewed;
           this.item.id = renewed.id;
           this.object = JSON.parse(JSON.stringify(renewed));
           this.inSave = false;
           this.toView();
         }
       } catch(error) {
         this.inSave = false;
       }
     },
     setBasis(value) {
       this.object.basis = value;
     },
     async kill() {
       if (await this.$repo.killObject(this.object, 'tsr')) {
         this.$emit('delete');
       }
     }
   },
   mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
     this.deleteAllowed = userService.isDeleteAllowed();
   }
 }
</script>
